import { BrowserRouter } from 'react-router-dom'
import { ChakraProvider } from '@chakra-ui/react'
import { Toaster } from 'sonner'
import { AppRoutes } from './routes'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import theme from '@/styles/theme'

export function App() {
  return (
    <ChakraProvider theme={theme}>
      <ErrorBoundary>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="bottom-right" richColors />
        </BrowserRouter>
      </ErrorBoundary>
    </ChakraProvider>
  )
}
